import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/edit.png'


const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "boxContainer" }
const _hoisted_3 = {
  filter: "name",
  sort: "name"
}
const _hoisted_4 = {
  filter: "email",
  sort: "email"
}
const _hoisted_5 = {
  filter: "password",
  sort: "password"
}
const _hoisted_6 = {
  filter: "preferredCulture",
  sort: "preferredCulture"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  colspan: "10",
  class: "text-center pt-5"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("td", null, "*********", -1)
const _hoisted_11 = { class: "d-flex justify-content-end" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h3',
        localizedKey: "backoffice_Utenze",
        text: "Utenze",
        class: "text-uppercase fw_700 mb-0"
      }),
      _createVNode("button", {
        class: "primaryButton",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editUser(null)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "backoffice_NuovaUtenza",
          text: "Nuova utenza"
        })
      ])
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_op_table, {
        class: "table table-striped",
        items: _ctx.internalUsers,
        filtersFn: _ctx.filtersFn
      }, {
        default: _withCtx((opData) => [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              _createVNode("td", _hoisted_3, [
                _createVNode(_component_localized_text, {
                  localizedKey: "backoffice_Name",
                  text: "Name"
                })
              ]),
              _createVNode("td", _hoisted_4, [
                _createVNode(_component_localized_text, {
                  localizedKey: "backoffice_Email",
                  text: "Email"
                })
              ]),
              _createVNode("td", _hoisted_5, [
                _createVNode(_component_localized_text, {
                  localizedKey: "backoffice_Password",
                  text: "Password"
                })
              ]),
              _createVNode("td", _hoisted_6, [
                _createVNode(_component_localized_text, {
                  localizedKey: "backoffice_Lingua",
                  text: "Lingua"
                })
              ]),
              _hoisted_7
            ])
          ]),
          _createVNode("tbody", null, [
            (opData.data.length == 0)
              ? (_openBlock(), _createBlock("tr", _hoisted_8, [
                  _createVNode("td", _hoisted_9, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "backoffice_NessunElementoTrovato",
                      text: "Nessun elemento trovato"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(opData.data, (item, i) => {
              return (_openBlock(), _createBlock("tr", { key: i }, [
                _createVNode("td", null, _toDisplayString(item.name), 1),
                _createVNode("td", null, _toDisplayString(item.email), 1),
                _hoisted_10,
                _createVNode("td", null, _toDisplayString(item.preferredCulture), 1),
                _createVNode("td", _hoisted_11, [
                  _createVNode("button", {
                    class: "secondaryButton squareButton me-2",
                    onClick: _withModifiers(($event: any) => (_ctx.editUser(item)), ["stop"])
                  }, [
                    _hoisted_12
                  ], 8, ["onClick"])
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["items", "filtersFn"])
    ])
  ], 64))
}